"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformChildSeatsToString = transformChildSeatsToString;
const lodash_1 = require("lodash");
const transformChildSeatTypeToString_1 = require("./transformChildSeatTypeToString");
function transformChildSeatsToString(childSeats) {
    const seatTypeCounts = (0, lodash_1.countBy)(childSeats);
    return Object.entries(seatTypeCounts)
        .map(([seatType, count]) => `${count}x ${(0, transformChildSeatTypeToString_1.transformChildSeatTypeToString)(Number(seatType))}`)
        .join("\n");
}
//# sourceMappingURL=transformChildSeatsToString.js.map